import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { rsProgress, rsParentCom } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseLandingLinkGrid } from "./UseLandingLinkGrid";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function LandingLinkGridItems(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { deleteLandingLinkGridItem, updateLandingLinkGridItem } =
    UseLandingLinkGrid();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const location = useLocation();
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    if (props.itemID) {
      return navigate("addItem", {
        state: {
          search: searchSubGroup,
          categoryID: props.categoryID,
          itemID: props.itemID,
          rows: props.items,
          componentFaTitle: location.state.componentFaTitle,
        },
      });
    } else {
      enqueueSnackbar("ابتدا اطلاعات فوق را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title ? cellValues.row.title : "-"}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("editItem", {
                    state: {
                      row: cellValues.row,
                      categoryID: props.categoryID,
                      componentFaTitle: location.state.componentFaTitle,
                      itemID: props.itemID,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  updateLandingLinkGridItem(model, "", "", () =>
                    props.callback(),
                  );
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == props.items.length + 1) {
                  return;
                } else {
                  updateLandingLinkGridItem(model, "", "", () =>
                    props.callback(),
                  );
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={props.items ? props.items : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.items && props.items.length ? props.items.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount:
              props.items && props.items.length ? props.items.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"آیتم"}
        callback={() => {
          setProgress(true);
          deleteLandingLinkGridItem(deleteState.id, () => {
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
